import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import { connect } from 'react-redux';
import * as Actions from 'actions';

class MenuItem extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'MenuItem';
        this.generateChildren = this.generateChildren.bind(this);
        this.navigateTo = this.navigateTo.bind(this)
    }
    generateChildren (){
        if(this.props.children) {
            return (
                <ul class="nav nav-children">
                    {this.props.children}
                </ul>
            );
        }

    }
    navigateTo(e) {
        // e.preventDefault();
        $('html').removeClass('sidebar-left-opened'); //Closes menu.
        if(!this.props.ui.show_sidebar_container) {
        	this.props.toggleShowSidebarContainer(true)
        }
    }
    render() {
        var path = "/";
        var iconClass = "fa";
        var title = "";

        if(typeof this.props.title !== 'undefined')
            title = this.props.title;
        if(typeof this.props.iconClass !== 'undefined')
            iconClass = this.props.iconClass;
        if(typeof this.props.title !== 'undefined')
            title = this.props.title;
        if(typeof this.props.path !== 'undefined')
            path = this.props.path;

        const pathname = this.props.routing.locationBeforeTransitions.pathname;
        const listClass = RegExp(`^${path}$`).test(`/${pathname}`)? 'nav-active' : '';

        if(!this.props.children || typeof this.props.children === 'undefined')
            return(
        			<li className={listClass}>
                <Link onClick={this.navigateTo} to={path}>
                    {this.props.label? <span className="pull-right label label-primary">{this.props.label}</span> : null}
                    <i className={iconClass} aria-hidden="true"></i>
                    <span>{title}</span>
                </Link>
              </li>
            );
        else
            return(
                <li className={"nav-parent"}>
                    <a>
                        <i className={iconClass} aria-hidden="true"></i>
                        <span>{title}</span>
                    </a>
                    <ul className="nav nav-children">
                        {this.props.children}
                    </ul>

                </li>
            );
    }
}

MenuItem.contextTypes = {
  router : PropTypes.object
}

const mapStateToProps = ({routing, ui}) => ({routing, ui})

export default connect(mapStateToProps, Actions)(MenuItem);



// WEBPACK FOOTER //
// ./src/browser/components/ui/menuItem.js